const CompanyInfo = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/d9f2ea0d9defb7f5e706cfcb4cc442a5.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 border border-[#2D5016] rounded-full mb-6">
            <span className="text-[#2D5016] text-sm font-medium">La Nostra Storia</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-serif text-[#2D5016] mb-4">
            AGRO-INNOVAZIONI S.r.l
          </h1>
          <p className="text-xl text-gray-600">
            Eccellenza Biologica dal Cuore dell'Italia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              AGRO-INNOVAZIONI S.r.l nasce dalla passione per la qualità e il rispetto della natura. 
              La nostra missione è portare nelle case italiane prodotti biologici di altissima qualità, 
              selezionati con cura e certificati secondo i più rigorosi standard europei.
            </p>
            <p className="text-lg">
              Ogni spezia e ogni biscotto che produciamo racconta una storia di dedizione, tradizione 
              e innovazione. Lavoriamo direttamente con agricoltori biologici certificati, garantendo 
              la tracciabilità completa di ogni prodotto dal campo alla tavola.
            </p>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              La nostra filosofia si basa su tre pilastri fondamentali: qualità senza compromessi, 
              sostenibilità ambientale e trasparenza totale verso i nostri clienti. Crediamo che il 
              cibo biologico non sia solo una scelta salutare, ma un modo per prendersi cura del 
              pianeta e delle generazioni future.
            </p>
            <p className="text-lg">
              Oggi AGRO-INNOVAZIONI è un punto di riferimento nel settore delle spezie biologiche 
              e dei prodotti da forno artigianali, con una rete di clienti che apprezzano la nostra 
              dedizione alla qualità e all'autenticità.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 bg-[#FAF8F5] rounded-2xl">
            <div className="w-16 h-16 flex items-center justify-center bg-[#2D5016] rounded-full mx-auto mb-4">
              <i className="ri-leaf-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2D5016] mb-2">100% Biologico</h3>
            <p className="text-gray-600 text-sm">
              Tutti i nostri prodotti sono certificati biologici secondo le normative EU
            </p>
          </div>

          <div className="text-center p-8 bg-[#FAF8F5] rounded-2xl">
            <div className="w-16 h-16 flex items-center justify-center bg-[#2D5016] rounded-full mx-auto mb-4">
              <i className="ri-recycle-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2D5016] mb-2">Sostenibilità</h3>
            <p className="text-gray-600 text-sm">
              Packaging eco-friendly e processi produttivi a basso impatto ambientale
            </p>
          </div>

          <div className="text-center p-8 bg-[#FAF8F5] rounded-2xl">
            <div className="w-16 h-16 flex items-center justify-center bg-[#2D5016] rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2D5016] mb-2">Tracciabilità</h3>
            <p className="text-gray-600 text-sm">
              Ogni prodotto è tracciabile dal campo alla tavola per garantire massima sicurezza
            </p>
          </div>
        </div>

        <div className="bg-[#8B9D7C] rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-serif mb-4">I Nostri Valori</h3>
          <p className="text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
            Crediamo nell'importanza di un'alimentazione sana e consapevole. Ogni giorno lavoriamo 
            per offrire prodotti che rispettino la terra, le persone e le tradizioni culinarie italiane, 
            portando nelle vostre case il meglio che la natura biologica può offrire.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;